import React, {lazy, Suspense} from 'react';
import {Helmet} from 'react-helmet';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import LoadingStatusComponent from "src/components/common/LoadingStatusComponent";

const AppMainLayout = lazy(() => import('src/components/AppMainLayout'))
const WidgetMainLayout = lazy(() => import('src/components/WidgetMainLayout'))

export class App extends React.Component {
    render() {
        return (
            <>
                <Helmet>
                    <meta name="viewport" content="width=device-width, initial-scale=1"/>
                </Helmet>
                <BrowserRouter>
                    <Routes>
                        <Route path="/irc/widget" element={
                            <Suspense fallback={<LoadingStatusComponent/>}>
                                <WidgetMainLayout/>
                            </Suspense>
                        }/>
                        <Route path="*" element={
                            <Suspense fallback={<LoadingStatusComponent/>}>
                                <AppMainLayout/>
                            </Suspense>}/>
                    </Routes>
                </BrowserRouter>
            </>
        );
    }
}

export default App;
